import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {APIConfig} from '../app.constant';
import {Observable} from 'rxjs/Observable';
import {HttpHeaders} from '@angular/common/http';
import {SessionService} from './session.service';
import {ResponseOption} from '../models/responseOption.model';

@Injectable()
export class ResponseOptionService extends BaseService {

  getResponseOptions(): Observable<ResponseOption[]> {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
    return this.http.get<ResponseOption[]>(APIConfig.API_RESPONSE_OPTION_URL, this.options);
  }

}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/services/responseOption.service.ts